import React from 'react';
import styles from './InputComponents.module.css';

const ConditionalInput = ({ question, data, onUpdate, renderQuestion, shouldShow, isSubmitted }) => {
    if (!shouldShow) return null;

    const checkConditionalLogic = (subQuestion, parentQuestion) => {
        if (!parentQuestion.conditionalLogic) return true;

        const { condition, value } = parentQuestion.conditionalLogic;
        const conditionValue = data[condition];

        return conditionValue === value;
    };

    return (
        <div className={styles.conditionalWrapper}>
            <div className={styles.conditionalHeader}>
                <h4 className={styles.conditionalTitle}>{question.text}</h4>
            </div>
            <div className={styles.conditionalContent}>
                {Array.isArray(question.questions) ? (
                    question.questions.map((subQuestion, index) => {
                        if (index === 0) {
                            return (
                                <div key={subQuestion.id} className={styles.conditionalQuestion}>
                                    {renderQuestion(subQuestion, index)}
                                </div>
                            );
                        }

                        const shouldShowNested = checkConditionalLogic(subQuestion, question);
                        if (!shouldShowNested) return null;

                        return (
                            <div key={subQuestion.id} className={styles.conditionalQuestion}>
                                {renderQuestion(subQuestion, index)}
                            </div>
                        );
                    })
                ) : question.questions && typeof question.questions === 'object' ? (
                    <div className={styles.tableWrapper}>
                        {renderQuestion({ ...question, type: 'table' }, 0)}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ConditionalInput;